import { type ActivateTraderRequest, type ConfigForm, type UpdateTraderRateRequest } from '../../model';

export const transformValues = <T extends ActivateTraderRequest | ConfigForm | UpdateTraderRateRequest>(
    values: T,
): T => {
    const convert = (value: unknown): unknown => {
        if (typeof value === 'number') {
            return String(value);
        }

        if (value === null || value === undefined) {
            return value;
        }

        if (Array.isArray(value)) {
            return value.map(convert);
        }

        if (typeof value === 'object') {
            return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, convert(val)]));
        }

        return value;
    };

    return convert(values) as T;
};
